<template>
  <b-modal id="individual-create-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal">{{ copyData ? $t('voc.copy_event') : $t('voc.create_event') }}</h5>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.source') }}</div>
        <div class="adp-p">{{ $t('idp.individual') }}</div>
      </div>

      <div class="adp-modal-row" v-if="$role === 'hr' || $role === 'admin'">
        <div class="adp-p adp-p__grey">{{ $t('voc.author_assignment') }}</div>
        <div class="adp-p">{{ currentUser ? currentUser.fio+' ('+currentUser.pernumber+')' : '-' }}</div>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.group') }}* ({{ $t('modal.required_field') }})</label>
        <v-select :options="groupOptions" v-model="group" :reduce="option => option.code" @input="resetFunctionModel">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row" v-if="functionOptions.length">
        <label class="adp-p adp-p__grey">{{ $t('catalog.function') }}* ({{ $t('modal.required_field') }})</label>
        <v-select :options="functionOptions" v-model="functionModel" :reduce="option => option.code" @input="resetCompetencies">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <template v-if="competenciesList[0] && competenciesList[0].id !== null">
        <template v-for="(competence, i) in competencies">
          <competence-skills-block v-on:delete-competence="onDeleteCompetence(i)"
                                  v-on:select-competence="onSelectCompetence(i)"
                                  v-on:change-competence-object="onChangeCompetenceObject($event, i)"
                                  :competence-list="competenciesList"
                                  :not-selected-competencies="notSelectedCompetencies"
                                  :has-delete-button="i !== 0"
                                  :key="i" :competence-number="i+1"
                                  :competence-obj="competence"
          >
          </competence-skills-block>
        </template>
      </template>
      <div class="btn adp-btn-outline" @click="addCompetenceField" v-if="competencies.length < competenciesList.length">
        + {{ $t('catalog.add_another_competence')}}
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.format') }}* ({{ $t('modal.required_field') }})</label>
        <v-select :options="formatOptions" v-model="format" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row" v-if="typeOptions.length">
        <label class="adp-p adp-p__grey">{{ $t('catalog.type') }}</label>
        <v-select :options="typeOptions" v-model="type" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row" v-if="resourceOptions.length">
        <label class="adp-p adp-p__grey">{{ $t('catalog.resource') }}</label>
        <v-select :options="resourceOptions" v-model="resource" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row" v-if="methodOptions.length">
        <label class="adp-p adp-p__grey">{{ $t('catalog.method') }}</label>
        <v-select :options="methodOptions" v-model="method" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.name') }}* ({{ $t('modal.required_field') }})</label>
        <input type="text" v-model="name" class="adp-input adp-input__text">
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.provider') }}</label>
        <v-select :options="providerOptions" v-model="provider" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.trainer_fio') }}</label>
        <input type="text" v-model="coachFio" class="adp-input adp-input__text" @input="$emit('coachFioInput', $event.target.value)">
        <div class="adp-modal-row-search" v-if="searchedEmployees.length > 0">
          <div v-for="employee in searchedEmployees" class="adp-modal-row-search__item" @click="selectCoach(employee.fio)">
            <span class="pl-3 w-100">{{ employee.fio }}</span>
          </div>
        </div>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.duration') }}</label>
        <input type="text" v-model="duration" class="adp-input adp-input__text" @beforeinput="validateIntegerInput($event)">
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.target_group') }}</label>
        <v-select :options="targetGroupOptions" v-model="targetGroup" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>

      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.description') }}</label>
        <textarea rows="5" v-model="description" class="adp-input adp-input-textarea" style="min-height: calc(5lh + 6px);"></textarea>
      </div>

      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">{{ $t('catalog.program') }}</label>
        <div v-if="programFiles.length > 0">
          <div class="d-flex" v-for="(file, i) in programFiles">
            <div class="d-flex align-items-center adp-modal-row-file" >{{ file.name }}</div>
            <div class="btn adp-btn-outline float-right ml-auto" @click="deleteFile(i, 'programFiles')">
              {{ $t('modal.delete') }}
            </div>
          </div>
        </div>
        <div class="btn adp-btn-outline float-right ml-auto" @click="attachFiles('programFiles')">
          {{ $t('catalog.add_another_files') }}
        </div>
        <input type="file" multiple hidden id="upload-files-program" @change="addFile($event, 'programFiles')">
      </div>

      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">{{ $t('catalog.educational_materials') }}</label>
        <div v-if="educationalMaterialFiles.length > 0">
          <div class="d-flex" v-for="(file, i) in educationalMaterialFiles">
            <div class="d-flex align-items-center adp-modal-row-file" >{{ file.name }}</div>
            <div class="btn adp-btn-outline float-right ml-auto" @click="deleteFile(i, 'educationalMaterialFiles')">
              {{ $t('modal.delete') }}
            </div>
          </div>
        </div>
        <div class="btn adp-btn-outline float-right ml-auto" @click="attachFiles('educationalMaterialFiles')">
          {{ $t('catalog.add_another_files') }}
        </div>
        <input type="file" multiple hidden id="upload-files-education" @change="addFile($event, 'educationalMaterialFiles')">
      </div>

      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">{{ $t('catalog.when') }}* ({{ $t('modal.required_field') }})</label>
        <my-date-picker v-on:change="changeDateInterval($event)" :dates="deadline" :not-disable-range="true" :clearable="false"/>
      </div>

    </template>
    <template #modal-footer>
      <button id="delete" class="btn btn-primary adp-btn adp-btn__large ml-auto float-right" @click="formatCheck()"
        :disabled="!name || !functionModel || !group || nullableCompetencies || !format || !deadline || isLoading">
        {{ copyData ? $t('voc.save') : $t('voc.assign') }}
      </button>
    </template>

    <add-training-modal :learning-activity-name="name" @choose-training="save" />
  </b-modal>
</template>

<script>
import CompetenceSkillsBlock from "./../CompetenceSkillsBlock";
import api from "../../api";
import Vue from "vue";
import MyDatePicker from "../MyDatePicker";
import {modifyCompetences} from "../../updateUrl";
import AddTrainingModal from "./AddTrainingModal.vue";

export default {
  name: "IndividualCreateModal",
  components: {
    'add-training-modal':AddTrainingModal,
    'competence-skills-block': CompetenceSkillsBlock,
    'my-date-picker': MyDatePicker,
  },
  props: {
    learningActivityGroup: {
      type: String,
      required: true,
    },
    employeeType: {
      type: String,
      required: true,
    },
    groupsTree: {
      type: Array,
      required: true,
    },
    groupOptions: {
      type: Array,
      required: true,
    },
    providerOptions: {
      type: Array,
      required: true,
    },
    searchedEmployees: {
      type: Array,
      required: true,
    },
    copyData: {
      type: Object,
      default: () => null
    },
  },
  data: function () {
    return {
      isLoading: false,

      participant_pernumber: null,
      ttype: 'individual',
      name: '',
      group: '',
      functionModel: '',
      format: '',
      type: '',
      method: '',
      resource: '',
      provider: '',
      duration: '',
      coachFio: '',
      targetGroup: '',
      description: '',
      competencies: [null],
      deadline: null,

      formatOptions: [],
      functionOptions: [],
      typeOptions: [],
      resourceOptions: [],
      targetGroupOptions: [],
      methodOptions: [],

      activityFormats: {},
      programFiles: [],
      educationalMaterialFiles: [],

      competenciesList: [],
      notSelectedCompetencies: [],

      authorRole: '',

      nullableCompetencies: false,

      currentUser: null,
    }
  },
  watch: {
    competenciesList() {
      this.filterSelectedCompetencies();
    },
    format(newVal) {
      if (newVal === 'at_workplace') {
        this.type = '';
        this.resource = '';

        this.typeOptions = [];
        this.resourceOptions = [];
        this.methodOptions = this.activityFormats.at_workplace.methods.map(x => ({code: x, label: this.$t(`idp.method_${x}`)}));
      }
      if (newVal === 'interaction') {
        this.type = '';
        this.resource = '';

        this.typeOptions = [];
        this.resourceOptions = [];
        this.methodOptions = this.activityFormats.interaction.methods.map(x => ({code: x, label: this.$t(`idp.method_${x}`)}));
      }
      if (newVal === 'training') {
        this.method = '';

        this.typeOptions = this.activityFormats.training.types.map(x => ({code: x, label: this.$t(`idp.type_${x}`)}));
        this.resourceOptions = this.activityFormats.training.resources.map(x => ({code: x, label: this.$t(`idp.resource_${x}`)}));
        this.methodOptions = [];
      }
    },
    group(newVal) {
      const functions = this.groupsTree.filter(x => x.group_id === newVal).filter(x => x.func_is_hidden === 0);
      this.functionOptions = [...new Set(functions.map(x => x.func_id))].map(x => {
        return { code: x, label: functions.find(y => y.func_id === x).func_name };
      });
    },
    functionModel(newVal, oldVal) {
      if (newVal !== null) {
        const comps = this.groupsTree.filter(x => x.func_id === newVal).filter(x => x.comp_is_hidden === 0);
        this.competenciesList = [...new Set(comps.map(x => x.comp_id))].map(x => {
          return {
            id: x,
            name: comps.find(y => y.comp_id === x).comp_name,
            skills: comps.filter(y => y.comp_id === x)
              .filter(c => c.skill_is_hidden === 0)
              .map(c => ({id: c.skill_id, name: c.skill_name}))
          };
        });
      }
      if (!this.copyData && newVal !== oldVal) this.competencies = [null];
    },
  },
  methods: {
    selectCoach(fio) {
      this.coachFio = fio;
      this.$emit('closeCoachMenu');
    },
    resetFunctionModel() {
      this.functionModel = '';
      this.resetCompetencies();
    },
    resetCompetencies() {
      this.competenciesList = [];
      this.competencies = [null];
      this.$nextTick(() => this.nullableCompetencies = true);
    },
    addCompetenceField() {
      this.competencies.push(null);
      this.$nextTick(() => this.nullableCompetencies = true);
    },
    getDefaultValues() {
      this.name = '';
      this.group = '';
      this.functionModel = '';
      this.format = '';
      this.type = '';
      this.method = '';
      this.resource = '';
      this.provider = '';
      this.duration = '';
      this.coachFio = '';
      this.targetGroup = '';
      this.description = '';
      this.competencies = [null];
      this.deadline = null;
      this.programFiles = [];
      this.educationalMaterialFiles = [];
    },
    onChangeCompetenceObject(competenceObj, i) {
      this.competencies[i] = competenceObj;
      this.checkNullableCompetence();
    },
    onDeleteCompetence(index) {
      Vue.delete(this.competencies, index);
      this.filterSelectedCompetencies();
      this.checkNullableCompetence();
    },
    onSelectCompetence(i) {
      this.competencies[i].skills = [null];
      this.filterSelectedCompetencies();
      this.checkNullableCompetence();
    },
    changeDateInterval(e) {
      this.deadline = e;
    },
    checkNullableCompetence() {
      let hasNullCompetence = this.competencies.some(x => x === null || x.id === null);
      this.$nextTick(() => this.nullableCompetencies = hasNullCompetence);
    },
    filterSelectedCompetencies() {
      let selectedIds = this.competencies.filter(e => e).map(e => e.id);
      this.notSelectedCompetencies = this.competenciesList.filter((e) => selectedIds.includes(e.id) !== true);
    },
    async getCurrentUser() {
      await api.currentUserInfo().then(res => {
        this.currentUser = res.data;
      });
    },
    onShow() {
      this.participant_pernumber = this.$route.params.pernumber;
      if (window.IDP.role === '' || window.IDP.role === 'employee') {
        this.participant_pernumber = window.IDP.pernumber;
      }

      this.$emit('closeCoachMenu');
      const activity_formats = window.IDP.activity_formats;
      this.activityFormats = activity_formats;
      this.formatOptions = Object.keys(activity_formats).map(x => ({code: x, label: this.$t(`idp.format_${x}`)}));

      this.targetGroupOptions = window.IDP.activity_target_group.map(x => ({code: x, label: this.$t(`idp.target_group_${x}`)}));

      this.authorRole = window.IDP.role;

      if (!this.copyData) {
        this.getDefaultValues();
      } else {
        if (this.copyData.ttype) {
          this.ttype = this.copyData.ttype;
        }

        if (this.copyData.group) {
          this.group = this.copyData.group;

          const functions = this.groupsTree.filter(x => x.group_id === this.copyData.group).filter(x => x.func_is_hidden === 0);
          this.functionOptions = [...new Set(functions.map(x => x.func_id))].map(x => {
            return { code: x, label: functions.find(y => y.func_id === x).func_name };
          });
        }

        if (this.copyData.functionModel) {
          this.functionModel = this.copyData.functionModel;

          const comps = this.groupsTree.filter(x => x.func_id === this.copyData.functionModel).filter(x => x.comp_is_hidden === 0);
          this.competenciesList = [...new Set(comps.map(x => x.comp_id))].map(x => {
            return {
              id: x,
              name: comps.find(y => y.comp_id === x).comp_name,
              skills: comps.filter(y => y.comp_id === x)
                .filter(c => c.skill_is_hidden === 0)
                .map(c => ({id: c.skill_id, name: c.skill_name}))
            };
          });
        }

        if (this.copyData.competencies) {
          this.competencies = this.copyData.competencies;
        }

        if (this.copyData.format) {
          this.format = this.copyData.format;

          if (this.format.code === 'at_workplace') {
            this.methodOptions = this.activityFormats.at_workplace.methods.map(x => ({code: x, label: this.$t(`idp.method_${x}`)}));
          }
          if (this.format.code === 'interaction') {
            this.methodOptions = this.activityFormats.interaction.methods.map(x => ({code: x, label: this.$t(`idp.method_${x}`)}));
          }
          if (this.format.code === 'training') {
            this.typeOptions = this.activityFormats.training.types.map(x => ({code: x, label: this.$t(`idp.type_${x}`)}));
            this.resourceOptions = this.activityFormats.training.resources.map(x => ({code: x, label: this.$t(`idp.resource_${x}`)}));
          }
        }

        if (this.copyData.type) {
          this.type = this.copyData.type;
        }

        if (this.copyData.resource) {
          this.resource = this.copyData.resource;
        }

        if (this.copyData.method) {
          this.method = this.copyData.method;
        }

        if (this.copyData.name) {
          this.name = this.copyData.name;
        }

        if (this.copyData.provider) {
          this.provider = this.copyData.provider;
        }

        if (this.copyData.coachFio) {
          this.coachFio = this.copyData.coachFio;
        }

        if (this.copyData.duration) {
          this.duration = this.copyData.duration;
        }

        if (this.copyData.targetGroup) {
          this.targetGroup = this.copyData.targetGroup;
        }

        if (this.copyData.description) {
          this.description = this.copyData.description;
        }

        if (this.copyData.deadline) {
          this.deadline = this.copyData.deadline;
        }

        if (this.copyData.programFiles) {
          this.programFiles = this.copyData.programFiles;
        }

        if (this.copyData.educationalMaterialFiles) {
          this.educationalMaterialFiles = this.copyData.educationalMaterialFiles;
        }
      }
      
      this.checkNullableCompetence();
    },
    attachFiles(filesType) {
      let input;
      if (filesType === 'programFiles') input =  document.getElementById('upload-files-program');
      if (filesType === 'educationalMaterialFiles') input =  document.getElementById('upload-files-education');
      input.click();
    },
    addFile(e, filesType) {
      this[filesType].push(...e.target.files)
    },
    deleteFile(index, filesType) {
      this[filesType].splice(index, 1);
    },
    async formatCheck() {
      if (this.format === 'training' && this.$role !== 'hr') {
        this.$bvModal.show('add-training-modal');
      } else {
        await this.save();
      }
    },
    async save() {
      this.isLoading = true;
      const data = new FormData();
      const deadline = this.deadline ? new Date(this.deadline).toLocaleString() : '';

      data.append('participant_pernumber', String(this.participant_pernumber));
      data.append('type', this.ttype);
      data.append('name', this.name);
      data.append('group_id', String(this.group));
      data.append('function_id', String(this.functionModel));
      data.append('competences', JSON.stringify(modifyCompetences(this.competencies)));
      data.append('deadline', String(deadline));
      data.append('description', this.description);
      data.append('author_role', this.authorRole);
      data.append('coach_fio', this.coachFio);
      data.append('la_format', this.format);
      data.append('la_type', this.type ? this.type : '');
      data.append('la_resource', this.resource ? this.resource : '');
      data.append('la_method', this.method ? this.method : '');
      data.append('provider', this.provider ? this.provider : '');
      data.append('duration', this.duration ? this.duration : '');
      data.append('target_group', this.targetGroup ? this.targetGroup : '');
      if (!this.copyData) {
        this.programFiles.forEach(file => data.append('programs[]', file, file.name));
        this.educationalMaterialFiles.forEach(file => data.append('educational_materials[]', file, file.name));
      }

      try {
        const duplicateId = this.copyData ? this.copyData.activityId : '';
        let resp = await api.createIndividualEvent(data, duplicateId);
        if (resp.status === 201) {
          this.isLoading = false;
          this.$emit('individual-created');
        }
      } catch (e) {
        console.error(e.response.data);
        this.$toasts.error(JSON.stringify(e.response.data, null, 2), {
          duration: 700000,
        });
      }
    },
  },
  async mounted() {
    await this.getCurrentUser();
  }
}
</script>
